/**
 * Dosya seçme alanlarının kabul ettiği türler.
 *
 * Uzantıları tek yerde tutuyoruz: tarayıcıdan inen görseller sık sık
 * beklenmedik uzantılarla geliyor (Chrome JPEG'i .jfif olarak, Google
 * Görseller .webp olarak kaydediyor). Listede yoksa kullanıcı seçemiyor.
 */

/** JPEG ailesinin Windows/tarayıcı kaynaklı tüm uzantıları. */
const JPEG_UZANTILARI = ".jpg,.jpeg,.jfif,.jpe,.pjpeg,.pjp";

export const GORSEL_KABUL = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/avif",
  "image/gif",
  "image/bmp",
  JPEG_UZANTILARI,
  ".png,.webp,.avif,.gif,.bmp",
].join(",");

export const FOTOGRAF_KABUL = [
  "image/jpeg",
  "image/png",
  "image/webp",
  JPEG_UZANTILARI,
  ".png,.webp",
].join(",");



export const PDF_KABUL = "application/pdf,.pdf";

export const DOCX_KABUL =
  ".docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document";
